import React from "react";
import styled from "styled-components";
import {ExportIcon} from "../../../elements/ExportIcon";
import {logAction} from "../../../../logging/logEvent";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    cursor: pointer;
    flex-grow: 1;
    flex-shrink: 0;
    padding-bottom: 8px;
`;

const AttachmentContainer = styled.a`
    display: flex;
    flex-grow: 1;
    align-items: center;
    height: 30px;
    padding-left: 19px;
    padding-right: 11px;
    margin-bottom: 8px;
    border-radius: 13.5px;
    color: #28313d;
    text-decoration: none;
    background-color: #F5F2F0;
    transition: background-color 0.2s ease;
    :hover {
        background-color: #D6D0C8;
    }
`;

const baseDownloadUrl = `/TradeIdeasMonitor/monitor?page=com.youdevise.ids.controller.AttachmentController&attachmentId=`;

const TextContainer = styled.div`
    flex-grow: 1;
`;

const Text = styled.div`
    max-width: 200px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;

const Attachment = ({id, name}) => {
    const onClick = () => {
        logAction({
            type: "IDEA_ATTACHMENT_DOWNLOADED",
            id,
            name
        })
    };

    return <AttachmentContainer key={id}
                                className="t-attachment"
                                target="_blank"
                                onClick={onClick}
                                href={`${baseDownloadUrl}${id}`}>
        <TextContainer>
            <Text>{name}</Text>
        </TextContainer>
        <ExportIcon height="20px" width="20px"/>
    </AttachmentContainer>
};

const NoAttachment = styled.div`
    padding-bottom: 8px;
`;

export const Attachments = ({idea}) => {
    const attachments = idea.attachments;

    if (!attachments || attachments.length === 0) {
        return <NoAttachment className="t-attachment">{"\u2014"}</NoAttachment>;
    }

    return <Container>
        {attachments.map(({id, name}) => <Attachment key={id} id={id} name={name}/>)}
    </Container>
};
